import { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PublishIcon from "@mui/icons-material/Publish";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import ArchiveIcon from "@mui/icons-material/Archive";
import DeleteIcon from "@mui/icons-material/Delete";
import ShareIcon from "@mui/icons-material/Share";
import HistoryIcon from "@mui/icons-material/History";

export default function ContentActionsMenu({
  row,
  onAction,
  disabled = false,
  deleting = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleAction = (action) => {
    setAnchorEl(null);
    onAction?.(action, row);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        aria-label="Ações"
        disabled={disabled}
      >
        {deleting ? (
          <CircularProgress size={18} />
        ) : (
          <MoreVertIcon fontSize="small" />
        )}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        keepMounted
        style={{ width: "fit-content", height: "100%" }}
      >
        <MenuItem
          onClick={() => handleAction("visualizar")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Visualizar" />
        </MenuItem>
        <MenuItem
          onClick={() => handleAction("editar")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Editar" />
        </MenuItem>
        <MenuItem
          onClick={() => handleAction("duplicar")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <ContentCopyIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Duplicar" />
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => handleAction("publicar")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <PublishIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Publicar" />
        </MenuItem>
        <MenuItem
          onClick={() => handleAction("despublicar")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <UnpublishedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Despublicar" />
        </MenuItem>
        <MenuItem
          onClick={() => handleAction("arquivar")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <ArchiveIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Arquivar" />
        </MenuItem>
        <MenuItem
          onClick={() => handleAction("excluir")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText
            primary="Excluir"
            primaryTypographyProps={{ color: "error" }}
          />
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => handleAction("compartilhar")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <ShareIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Compartilhar" />
        </MenuItem>
        <MenuItem
          onClick={() => handleAction("historico")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ListItemIcon>
            <HistoryIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Histórico" />
        </MenuItem>
      </Menu>
    </>
  );
}
